import React, { useEffect, useState } from "react";
import { Route, withRouter, useHistory } from "react-router-dom";
import Tab from "../../../../../Util/Tabs/Tab";
import Event from './Event';
import "./Events.css";
import { motion } from 'framer-motion';
import { pageTransitions, transitionDuration } from '../../../../../Util/PageTransitions';
import calIcon from "../../../../../assets/cal-icon-white.svg"
import listIcon from "../../../../../assets/list-icon.svg"
function Events(props) {
  const history = useHistory();
  const [calendarView, setCalendarView] = useState(false);
  const tabs = [
    {
      name: 'Events',
      url: ''
    },
  ];

  return (
    <>
      <motion.div className='outer-wrapper cs-leads-page' initial={pageTransitions.initial} animate={pageTransitions.in} exit={pageTransitions.out} transition={{ duration: transitionDuration }}>
        <div className="content-wrapper leagues-wrapper">
          <div className="heading-wrapper">
            <h2 className="heading">{'Events'}</h2>
          </div>
          <div className="tab-view-btns">
            <Tab tabs={tabs} type="leads_module" />
            {
              props.type !== 'public-events' &&
              <div className="view-btns">
                <div onClick={() => history.push('?calendar')} className="view-btn">
                  <img src={calIcon} alt="" />
                </div>
                <div onClick={() => history.push('/admin/events/')} className="view-btn">
                  <img src={listIcon} alt="" />
                </div>
              </div>
            }

          </div>
          <Route path={`${props.match.path}`} exact>
            <Event {...props} calendarView={calendarView} />
          </Route>
        </div>
      </motion.div>
    </>
  );
}

export default withRouter(Events);
